'use client';

import { exposeClassnames as classnames } from '@stadionhq-v3/utilities';
import {
  ARTICLE_TYPES,
  VideoCollectionCard,
  VideoFeaturedCard,
  VideoProgressBar,
} from '@stadionhq-v3/base-ui';
import styles from './videoCard.module.scss';
import categoryStyles from '../../atoms/category-link/categoryLink.module.scss';
import dateStyles from '../../atoms/date/date.module.scss';
import { VideoCardProps, VideoHeroCardProps } from './videoCard.types';
import ArticleCard from '../article-card';

const VideoCard = ({
  /* props */
  nativeProps,
  classNames,
  type = 'default',
  ...props
}: VideoCardProps) => {
  const classes = classnames(
    [styles.tokens, styles.videoCard, styles[type]],
    classNames
  );

  if (type === 'playlist') {
    return (
      <ArticleCard
        {...nativeProps}
        classNames={[classnames(classes)]}
        cardIconClassNames={[classnames(styles.cardIcon)]}
        titleClassNames={[classnames(styles.title)]}
        durationClassNames={[classnames(styles.duration)]}
        data-component="VideoPlaylistCard"
        variant="mini"
        type={ARTICLE_TYPES.video}
        isVideoCard
        {...props}
      />
    );
  }

  if (type === 'hero') {
    const { progressBar, ...rest } = props as VideoHeroCardProps;

    return (
      <div className={classnames(classes)}>
        <ArticleCard
          {...nativeProps}
          classNames={[classnames(styles.heroCard)]}
          cardIconClassNames={[classnames(styles.cardIcon)]}
          titleClassNames={[classnames(styles.title)]}
          durationClassNames={[classnames(styles.duration)]}
          data-component="VideoHeroCard"
          variant="mini"
          isVideoCard
          {...rest}
          type={ARTICLE_TYPES.video}
        />
        {progressBar && (
          <VideoProgressBar
            {...progressBar}
            classNames={[classnames(styles.progressBar)]}
          />
        )}
      </div>
    );
  }

  if (type === 'featured') {
    return (
      <VideoFeaturedCard
        {...props}
        category={
          props.category && {
            ...props.category,
            classNames: [
              classnames(
                categoryStyles.categoryLink,
                props.onDark && categoryStyles.onDark
              ),
            ],
          }
        }
        publishDate={
          props.publishDate && {
            ...props.publishDate,
            classNames: [
              classnames(dateStyles.date, props.onDark && dateStyles.onDark),
            ],
          }
        }
        type={type}
        classNames={[classnames(classes)]}
      />
    );
  }

  if (type === 'collection') {
    return (
      <VideoCollectionCard
        {...nativeProps}
        classNames={[classnames(classes)]}
        data-component="VideoCollectionCard"
        type="collection"
        {...props}
      />
    );
  }

  return (
    <ArticleCard
      {...nativeProps}
      classNames={[classnames(classes)]}
      data-component="VideoDefaultCard"
      type={ARTICLE_TYPES.video}
      isVideoCard
      {...props}
    />
  );
};

export default VideoCard;
